/* Timeline spine. Sets --lvp-tl-fill (0..1) from scroll position and lights
   each card once the fill reaches its avatar.

   The anchor is 62% of the viewport height — measured off the source at two
   different viewport heights (372/600 and 558/900) to confirm it scales with
   the viewport rather than being a fixed pixel offset. */
window.lvTlInit = function (listId) {
  var list = document.getElementById(listId);
  if (!list || list.dataset.lvInit) return;
  list.dataset.lvInit = '1';

  var rows = [].slice.call(list.querySelectorAll('.lvp-tlrow'));
  if (!rows.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    list.style.setProperty('--lvp-tl-fill', '1');
    for (var r = 0; r < rows.length; r++) rows[r].classList.add('is-lit');
    return;
  }

  var ticking = false;

  function update() {
    ticking = false;
    var b = list.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var fill = (vh * 0.62 - b.top) / b.height;
    if (fill < 0) fill = 0;
    if (fill > 1) fill = 1;
    list.style.setProperty('--lvp-tl-fill', String(fill));

    /* the track is inset 34px top and bottom, so the fill ends here */
    var end = b.top + 34 + fill * (b.height - 68);

    for (var i = 0; i < rows.length; i++) {
      var ic = rows[i].querySelector('.lvp-tlrow__ic');
      var lit = false;
      if (ic) {
        var ib = ic.getBoundingClientRect();
        lit = (ib.top + ib.height / 2) <= end;
      }
      /* the first card lights as soon as the list is on screen, before the
         fill has started — matching the source */
      if (i === 0 && b.top < vh) lit = true;
      rows[i].classList.toggle('is-lit', lit);
    }
  }

  function onScroll() {
    /* a hidden tab never runs requestAnimationFrame, so a scroll there would
       queue a callback that only fires on return — or not at all. Update
       straight away in that case and keep rAF for the visible path. */
    if (document.hidden) { update(); return; }
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  /* re-sync on return, in case the page was scrolled while backgrounded */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) onScroll();
  });
  update();
};
